module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-46.407f820e.png";